import React, { useRef, useEffect } from 'react';
import Icon from '../../icon';
import { useTheme } from '../../theme/theming';
import useArrowButtonStyles from './styles';

export default function ArrowButton(props) {
  const theme = useTheme();
  const { onClick } = props;
  const classes = useArrowButtonStyles(props);
  return (
    <div onClick={onClick} className={classes.arrowButtonContainer}>
      <Icon
        height={props.size === 'small' ? '12px' : '18px'}
        name="Angle"
        color={
          props.inverted
            ? theme?.palette?.font?.invertedDefault
            : theme?.colors?.AccentColor
        }
        inverted
      />
    </div>
  );
}
